// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"8d907699","875":"d188e788"}[chunkId] + ".chunk.js";
};